import axios from 'src/utils/axios';
import type { QuestionnaireSchema } from 'src/components/WSCertificationSummary/types/QuestionnaireSchemaTypes';

export interface QuestionnaireAnswerFile {
  id: number;
  survey_answer_id: number;
  pdf_file: string;
  pdf_file_url: string;
  status: number;
  added_to_answer: boolean;
  survey_file_date: string | null;
}

export interface QuestionnaireAnswer {
  id: number;
  qit_id: number;
  survey_id?: number;
  text: string | null;
  text_area: string | null;
  carry_over: string | null;
  is_rejected: boolean;
  status: string;
  answer_group_id: number;
  question_choices: Array<{ id: number; name: string }>;
  files: QuestionnaireAnswerFile[];
  parent_file_qit_id: number | null;
  parent_file_id: number | null;
  children_answers: QuestionnaireAnswer[];
  ai_extracted?: boolean | null;
  ai_confidence?: number | null;
  ai_extraction_method?: string | null;
  ai_source_file_id?: number | null;
  ai_extraction_metadata?: Record<string, unknown> | null;
  ai_extracted_at?: string | null;
}

export interface QuestionnaireAnswersMap {
  [qitId: number]: {
    [surveyId: number]: {
      [answerGroupId: number]: QuestionnaireAnswer;
    };
  };
}

export interface SaveAnswerPayload {
  qit_id: number;
  text?: string;
  text_area?: string;
  question_choices?: number[];
  answer_group_id?: number;
  parent_file_id?: number;
}

export async function fetchQuestionnaireSchema(
  certificationConfigId: number
): Promise<QuestionnaireSchema> {
  const { data } = await axios.get(
    `v2/certification/certification_config/${certificationConfigId}/questionnaire_schema/`
  );
  return data;
}

export async function fetchQuestionnaireAnswers(
  certificationId: number
): Promise<QuestionnaireAnswersMap> {
  const { data } = await axios.get(
    `v2/certification/certification/${certificationId}/questionnaire_answers/`
  );
  return data;
}

export async function createAnswer(
  surveyId: number,
  payload: SaveAnswerPayload
): Promise<void> {
  await axios.post(`v2/questionnaire/survey/${surveyId}/answer/`, payload);
}

export async function updateAnswer(
  surveyId: number,
  answerId: number,
  payload: Omit<SaveAnswerPayload, 'qit_id'>
): Promise<void> {
  await axios.patch(
    `v2/questionnaire/survey/${surveyId}/answer/${answerId}/`,
    payload
  );
}

export async function deleteAnswerGroup(answerGroupId: number): Promise<void> {
  await axios.delete(`questionnaire/answer_group/${answerGroupId}/`);
}
